module.exports = __webpack_public_path__ + "static/media/discussion-hero-img.c03eb0d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/discussion-hero-img.png
// module id = 1903
// module chunks = 0